import { useMutation } from '@apollo/client'
import { useCallback } from 'react'

import {
  CartFragment,
  SetCartAttributesDocument,
  SetCartAttributesMutationVariables,
} from '../../../../graphql/magento'
import { CartType } from '../../reducers/cart-get-state'

export type UseCartUpdateAttributes = {
  updateCartAttributes: (options: UpdateCartAttributesOptions) => Promise<CartFragment | undefined>
}

export type UpdateCartAttributesOptions = {
  token: string
  cartId: string
  cartAttributes: CartUpdateAttributesVariables
  cartType: CartType
}

export type CartUpdateAttributesVariables = Omit<SetCartAttributesMutationVariables, 'cartId'>

export const useCartUpdateAttributes = (): UseCartUpdateAttributes => {
  const [setCartAttributesMutation] = useMutation(SetCartAttributesDocument)

  const updateCartAttributes = useCallback(
    async ({
      token,
      cartId,
      cartAttributes,
      cartType,
    }: UpdateCartAttributesOptions): Promise<CartFragment | undefined> => {
      const { data } = await setCartAttributesMutation({
        variables: { cartId, ...cartAttributes },
        context: {
          token: cartType === 'customer' ? token : undefined,
        },
      })
      return data?.setCartAttributes?.cart
    },
    [setCartAttributesMutation],
  )

  return { updateCartAttributes }
}
